import TableSort from '@root/core/components/Table/Sort';
import { IFilter } from '@root/modules/Sellers/Product/interfaces';
import {
  OrderStatus,
  OrderStatusText,
  ProcessType,
  ReturnStatus,
  ReturnStatusLabel,
  ReturnType,
  ReturnTypeLabel,
  WarehouseReturnStatus
} from '@root/modules/Sellers/Shipping/enum';
import Excel from '@root/utils/helpers/excel';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Col, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import busksellerdetail from '../services/busksellerdetail';

interface Props {
  type: 'RETURN' | 'DISPOSAL' | 'TRACKING';
}

const ReturnList = ({ type }: Props) => {
  const { id } = useParams<{ id: string }>();

  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState(false);
  const [selectedIds, setSelectedIds] = useState<React.Key[]>([]);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState();
  const [totalRows, setTotalRows] = useState(0);

  let columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no'
    },
    {
      title: '분류',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: '상품명',
      dataIndex: 'productName',
      key: 'productName'
    },
    {
      title: 'SKU',
      dataIndex: 'productSku',
      key: 'productSku'
    },
    {
      title: '물류센터명',
      dataIndex: 'warehouseName',
      key: 'warehouseName'
    },
    {
      title: '상태',
      dataIndex: 'status',
      key: 'status'
    },
    {
      title: '사유',
      dataIndex: 'reason',
      key: 'reason'
    },
    {
      title: <TableSort title="업데이트일" sort={sort} setSort={setSort} />,
      dataIndex: 'updatedAt',
      key: 'updatedAt'
    }
  ];

  const listStatus = [
    {
      code: 'Inprogress',
      name: '배송 요청'
    },
    {
      code: 'Completed',
      name: '배송 완료'
    }
  ];

  const listStatusDisposal: any = {
    Request: '폐기 요청',
    Inprogress: '폐기중',
    Completed: '폐기 완료'
  };

  const filter: IFilter = {};
  let downloadFileName = '';

  switch (type) {
    case 'RETURN':
      filter.type = ProcessType.Return;
      filter.returnType = [ReturnType.Order].join();
      downloadFileName = 'Seller_Return';
      break;
    case 'DISPOSAL':
      filter.type = ProcessType.Disposal;
      // filter.returnType = [ReturnType.Import, ReturnType.Stock].join();
      columns = columns.filter((column) => column.key !== 'type');
      downloadFileName = 'Seller_Disposal';
      break;
    case 'TRACKING':
      filter.screenName = 'BUSK_SELLER_TRACKING';
      columns = columns.filter((column) => column.key !== 'type');
      downloadFileName = 'Seller_Tracking';
      break;
  }

  const getReturns = async () => {
    setLoading(true);
    const result = await busksellerdetail.getReturns(id, {
      page,
      limit: 10,
      filter,
      sortBy: sort ? 'updated_at:ASC' : 'updated_at:DESC'
    });
    const data = result.data?.map((r: any, index: number) => {
      let status = ReturnStatusLabel[r.status as ReturnStatus];

      if (type === 'DISPOSAL') {
        status = listStatusDisposal?.[r.status as any];
      }

      if (type === 'TRACKING') {
        status = OrderStatusText[r.orderStatus as OrderStatus];
      }

      return {
        ...r,
        key: r.returnId,
        no: r.returnId,
        type: ReturnTypeLabel[r.type as ReturnType],
        status,
        updatedAt: formatDateTime(r.updatedAt)
      };
    });

    setRows(data);
    setTotalRows(result?.meta?.totalItems ?? 0);
    setLoading(false);
  };

  useEffect(() => {
    getReturns();
  }, []);

  useEffect(() => {
    getReturns();
  }, [page, sort]);

  const handelExportExcel = async () => {
    const excelOption = {
      blod: undefined,
      fileName: downloadFileName
    };

    excelOption.blod = await busksellerdetail.returnExportExcel(id, {
      sortBy: sort ? 'updated_at:ASC' : 'updated_at:DESC',
      filter,
      screen: type === 'TRACKING' ? 'ReturnTracking' : '' ,
      listId: selectedIds.map((item) => Number(item))
    });

    Excel.download(excelOption);
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedIds(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedIds,
    onChange: onSelectChange
  };

  return (
    <>
      <div className="busk-sellerSubHead">
        <Row align="middle">
          <Col flex="auto">
            <Row gutter={15}>
              <Col>
                <Typography.Text>
                  {type === 'RETURN'
                    ? '총 반품'
                    : type === 'DISPOSAL'
                    ? '총 폐기'
                    : '총 반환'}{' '}
                  {totalRows}
                </Typography.Text>
              </Col>
              <Col>|</Col>
              <Col>
                <Typography.Text>
                  {type === 'RETURN'
                    ? '선택 반품'
                    : type === 'DISPOSAL'
                    ? '선택 폐기'
                    : '선택 반환'}{' '}
                  {selectedIds.length}
                </Typography.Text>
              </Col>
            </Row>
          </Col>
          <Col>
            <Button
              style={{
                color: 'gray'
              }}
              onClick={handelExportExcel}
            >
              엑셀 다운로드
            </Button>
          </Col>
        </Row>
      </div>

      <Table
        className="busk-table"
        rowSelection={rowSelection}
        pagination={{
          pageSize: 10,
          total: totalRows,
          onChange: (newPage) => {
            setPage(newPage);
          }
        }}
        loading={loading}
        columns={columns}
        dataSource={rows}
      />
    </>
  );
};

export default ReturnList;
